export default __webpack_public_path__ + "media/react/gre/adaptive_prep_v2/assets/practice_card_2-6966410765e8bf393cdf2d34f362f356.svg";